import { URL } from "../../utils/UrlConstants";
import { privateFetch } from "../../utils/CustomFetch.js";
import { properties } from "../../utils/Properties_es";
import { CONSTANT } from "../../utils/Constants";

export const getRequest = async () => {
  let responseData = {};  
  await privateFetch
    .get(
      URL.REQUEST_ROLE(null)
    )
    .then(async (response) => {
      responseData = await response.data;
    })
    .catch((error) => {
      //throw new Error(properties.com_parval_label_role_find_error);
      throw new Error(error);
    });
  return responseData;
};

export const findByIdRequest = async (id:any) => {
  let responseData = {};
  await privateFetch
    .get(URL.REQUEST_ROLE(id), {
      headers: {
        ...CONSTANT.HEADER_TYPE,
      },
    })
    .then(async (response) => {
      responseData = await response.data;
    })
    .catch(async (error) => {
      throw new Error(properties.com_parval_label_role_findid_error);
    });
  return responseData;
};

export const createRequest = async (data:any) => {
  let responseData = {};
  const params = new URLSearchParams([    
    ["id", 0],
    ["adminLogin", data.adminLogin ? 1 : 0],
    ["clientLogin", data.clientLogin ? 1 : 0],
    ["description", data.description],
    ["name", data.name],
  ]);  
  await privateFetch
    .put(URL.REQUEST_ROLE_CREATE,  {
      headers: {
        ...CONSTANT.HEADER_TYPE,
      },
    },  
    { params }  )
    .then(async (response) => {
      responseData = await response.data;
    })
    .catch(async (error) => {
      throw new Error(properties.com_parval_label_role_save_error);
    });
  return responseData;
};

export const updateRequest = async (data:any) => {
  let responseData = {};  
  const requestBody = {
    id: data.id,
    name: data.name,
    description: data.description,
    adminLogin: data.adminLogin,
    clientLogin:data.clientLogin,
  };
  await privateFetch
    .put(URL.REQUEST_ROLE_UPDATE, JSON.stringify(requestBody),{
      headers: {
        ...CONSTANT.HEADER_TYPE,
      },
    })
    
    .then(async (response) => {
      responseData = await response.data;
    })
    .catch(async (error) => {
      throw new Error(properties.com_parval_label_role_update_error);
    });
  return responseData;
};


export const deleteRequest = async (id:any) => {
  let responseData = {};
  await privateFetch
    .delete(URL.REQUEST_ROLE(id), {})
    .then(async (response) => {
      responseData = await response.data;
    })
    .catch(async (error) => {
      //throw new Error(properties.com_parval_label_role_delete_error);
      console.log(error)
    });
  return responseData;
};
